module.exports = __webpack_public_path__ + "static/Q3-2021_Investor_Call_Dial-in_information-f6454ea9b432ce3b8ea59969318d8853.pdf";